document.addEventListener("DOMContentLoaded", function () {
  function insertAndStyle() {
    const formEmbed = document.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      const shadow = formEmbed.shadowRoot;

      const teaserContainer = shadow.querySelector('._teaserContainer_trejf_5');
      const teaserHeading = shadow.querySelector('._teaserHeading_trejf_28');
      const closeButton = shadow.querySelector('._formCloseButton_1684x_4');
      const closeButtonSvgPath = closeButton?.querySelector('svg path');

      if (teaserContainer && teaserHeading && closeButton && closeButtonSvgPath) {

        teaserContainer.style.background = '#2B4454';
        teaserContainer.style.display = 'flex';
        teaserContainer.style.flexDirection = 'column';
        teaserContainer.style.position = 'relative';
        teaserContainer.style.alignItems = 'flex-start';  
        teaserContainer.style.textAlign = 'left';         
        teaserHeading.style.color = '#fff';

        teaserHeading.style.setProperty('font-family', 'var(--common-font)', 'important');
        teaserHeading.style.setProperty('font-weight', '500', 'important');

        closeButton.style.position = 'absolute';
        closeButton.style.top = '10px';
        closeButton.style.right = '10px';

        closeButtonSvgPath.style.fill = '#fff';

        if (!teaserContainer.querySelector('.custom-teaser-message')) {
          const newParagraph = document.createElement('p');
          newParagraph.textContent = "Not ready yet? No worries, secure your 10% gift now and use it when you’re ready. Don’t let it slip!";
          newParagraph.classList.add('custom-teaser-message');
          newParagraph.style.marginTop = '10px';
          newParagraph.style.fontSize = '14px';
          newParagraph.style.color = '#fff';
          newParagraph.style.margin = '0px';
          teaserContainer.appendChild(newParagraph);
        }

        if (!teaserContainer.querySelector('.custom-hold-gift-btn')) {
          const newButton = document.createElement('button');
          newButton.textContent = "Hold My 10% Gift →";
          newButton.classList.add('custom-hold-gift-btn');

          newButton.style.marginTop = '0px';
          newButton.style.padding = '12px 25px';
          newButton.style.fontWeight = '700';
          newButton.style.fontSize = '16px';
          newButton.style.color = '#fff';
          newButton.style.backgroundColor = 'transparent';
          newButton.style.border = '2px solid #fff';
          newButton.style.borderRadius = '5px';
          newButton.style.cursor = 'pointer';

          newButton.addEventListener('mouseenter', () => {
            newButton.style.backgroundColor = '#fff';
            newButton.style.color = '#202223';
          });
          newButton.addEventListener('mouseleave', () => {
            newButton.style.backgroundColor = 'transparent';
            newButton.style.color = '#fff';
          });

          teaserContainer.appendChild(newButton);
        }
      } else {
        setTimeout(insertAndStyle, 500);
      }
    } else {
      setTimeout(insertAndStyle, 500);
    }
  }

  setInterval(insertAndStyle, 10);
});


document.addEventListener('DOMContentLoaded', () => {
setInterval(() => {
  const formEmbed = document.querySelector('form-embed');
  const shadowRoot = formEmbed?.shadowRoot;

  if (shadowRoot) {
    const submitButton = shadowRoot.querySelector('._formSubmitButton_cit2d_96');

    if (submitButton) {
      submitButton.style.backgroundColor = '#2b4454';
      // Note: No clearInterval, so this runs repeatedly
      console.log('Background color applied (or re-applied)');
    } 
  } 
}, 300);


// Function to inject SVG and apply styles to the Klaviyo form button
function updateKlaviyoFormButton(button) {
  // SVG markup
  const svgHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="15" viewBox="0 0 33 15" fill="none">
      <path d="M1.5 6.5C0.947715 6.5 0.5 6.94772 0.5 7.5C0.5 8.05228 0.947715 8.5 1.5 8.5L1.5 7.5L1.5 6.5ZM32.2071 8.2071C32.5976 7.81658 32.5976 7.18341 32.2071 6.79289L25.8431 0.42893C25.4526 0.0384057 24.8195 0.0384058 24.4289 0.42893C24.0384 0.819455 24.0384 1.45262 24.4289 1.84314L30.0858 7.5L24.4289 13.1569C24.0384 13.5474 24.0384 14.1805 24.4289 14.5711C24.8195 14.9616 25.4526 14.9616 25.8431 14.5711L32.2071 8.2071ZM1.5 7.5L1.5 8.5L31.5 8.5L31.5 7.5L31.5 6.5L1.5 6.5L1.5 7.5Z" fill="#2B4454"/>
    </svg>
  `;

  // Create SVG element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = svgHTML.trim();
  const svgElement = tempDiv.firstChild;

  // Avoid multiple injections
  if (!button.querySelector('svg')) {
    button.appendChild(svgElement);
  }

  // Add a class for styling
  button.classList.add('custom-klaviyo-button');

  // Apply inline styles
  Object.assign(button.style, {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '25px',
    marginTop: '0',
    padding: '20px 40px',
    fontSize: '18px',
    fontWeight: '600',
    border: '1.5px solid #2b4454',
    borderRadius: '0px',
    textDecoration: 'none',
    height: 'unset',
    color: '#2b4454',
    backgroundColor: 'transparent',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  });

}

var checkInterval = setInterval(function() {
  const form = document.querySelector('form.klaviyo-form');
  if (form) {
    const button = form.querySelector('.needsclick button');
    if (button) {      
      updateKlaviyoFormButton(button);
    }
  }
}, 10);

// Wait for the Klaviyo form to load
const observer = new MutationObserver(() => {
  const form = document.querySelector('form.klaviyo-form');
  if (form) {
    const button = form.querySelector('.needsclick button');
    if (button) {
      updateKlaviyoFormButton(button);
      observer.disconnect(); // Stop observing
    }
  }
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});


  const accordions = document.querySelectorAll('accordion-custom details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', function (e) {
      // If already open, do nothing (or allow closing if needed)
      if (this.hasAttribute('open')) return;

      // Remove "open" from all other accordions
      accordions.forEach((acc) => {
        if (acc !== this && acc.hasAttribute('open')) {
          acc.removeAttribute('open');
        }
      });

      // Allow default behavior to open this one
    });
  });



  
});



  

